import i18n, { translate as t } from '@thoughtspot/i18n';
import _ from 'lodash';
const generateErrorParamMap = (parameters = []) => {
    return parameters.reduce((map, param, index) => {
        map[index + 1] = param;
        return map;
    }, {});
};
function getTranslatedInfoForMessageCode(code, defaultErrorMessage) {
    if (!code && !defaultErrorMessage) {
        return {
            title: undefined,
            summary: undefined,
            detail: undefined,
            action: undefined,
        };
    }
    const defaultMessage = defaultErrorMessage || 'error.validation.default';
    const getI18nKey = (type) => {
        const key = `msg_code.${code}.${type}`;
        return i18n.exists(key) ? key : undefined;
    };
    return {
        title: getI18nKey('title'),
        summary: getI18nKey('summary') || defaultMessage,
        detail: getI18nKey('detail'),
        action: getI18nKey('action'),
    };
}
function getTranslatedStringsForMessageCode(error, defaultErrorMessage) {
    if (!error?.code && !defaultErrorMessage) {
        return {
            title: '',
            summary: '',
            detail: '',
            action: '',
        };
    }
    const { code } = error || {};
    const translatedErrorInfo = getTranslatedInfoForMessageCode(code, defaultErrorMessage);
    const interpolationVars = error?.errorMappingContext ||
        generateErrorParamMap(error?.errorObj?.extensions?.parameters);
    const cleanInterpolationVars = _.omitBy(interpolationVars || {}, _.isNil);
    const summary = translatedErrorInfo.summary
        ? t(translatedErrorInfo.summary, cleanInterpolationVars)
        : '';
    const detail = translatedErrorInfo.detail
        ? t(translatedErrorInfo.detail, cleanInterpolationVars)
        : summary;
    const title = translatedErrorInfo.title
        ? t(translatedErrorInfo.title, cleanInterpolationVars)
        : '';
    const action = translatedErrorInfo.action
        ? t(translatedErrorInfo.action, cleanInterpolationVars)
        : undefined;
    return {
        title,
        summary,
        detail,
        action,
    };
}
export { getTranslatedInfoForMessageCode, getTranslatedStringsForMessageCode };
//# sourceMappingURL=error-strings-mapping.js.map